module.exports = __webpack_public_path__ + "img/refuses.f66ceaa4.svg";